<template>
  <div>
    <b-form @submit.prevent>
      <b-row>

        <!-- first name -->
        <b-col cols="12">
          <b-form-group
            label="Book ID"
            label-for="vi-book-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="selectedBook"
                :options="books"
                placeholder="Book Selector"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Chapter Number"
            label-for="vi-book-chapter"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="HashIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-chapter"
                v-model="book.chapter"
                placeholder="Chapter number"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-checkbox
            id="samples"
            v-model="samples"
            name="samples"
            value="true"
            unchecked-value="false"
          >
            Samples ( Select this for Find and Import functions)
          </b-form-checkbox>
        </b-col>

        <div class="demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="findPuzzles"
          >
            Find
          </b-button>

          <form action="">
            <input
              id="file-input"
              accept=".zip"
              type="file"
              name="file"
              style="border: 0;clip: rect(0 0 0 0);height: 1px;margin: -1px;overflow: hidden;padding: 0;position: absolute;width: 1px;"
              @change="uploadFile"
            >
          </form>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="showImportPopup"
          >
            Import
          </b-button>
        </div>
      </b-row>
    </b-form>
    <br>
    <b-table
      responsive
      selectable
      hoover
      :select-mode="selectMode"
      :items="items"
      class="mb-0"
      @row-selected="onRowSelected"
    >
      <template #cell(actions)="data">
        <span v-html="data.value" />
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BTable, BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTable,
    BFormSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      book: {},
      selectedBook: undefined,
      books: [],
      selectMode: 'single',
      items: [],
      samples: 'false',
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/puzzles-books`
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        console.log(response)
        this.books = response.data
        return response
      }).catch(error => {
        console.log(error)
        return error
      })
    })
  },
  methods: {
    importPuzzles() {
      this.$bvModal
        .msgBoxOk('Coming soon!', {
          title: 'Info',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Close',
          hideHeaderClose: false,
          centered: true,
        })
    },
    showImportPopup(event) {
      if (this.selectedBook === undefined) {
        alert('Please select a book')
      } else {
        this.$bvModal
          .msgBoxConfirm('Are you sure? This action will overwrite existing data', {
            cancelVariant: 'outline-secondary',
            okVariant: 'danger',
            centered: true,
          })
          .then(value => {
            if (value) {
              event.preventDefault()
              document.getElementById('file-input').click()
            }
          })
      }
    },
    uploadFile(event) {
      if (event.target.files && event.target.files.length > 0) {
        const formData = new FormData()
        formData.append('file', event.target.files[0])
        const url = `${this.$readerURL}/admin/puzzles-import/${this.selectedBook}?samples=${this.samples}`
        this.loader('block')
        const temp = this
        firebase.auth().currentUser.getIdToken(false).then(idToken => {
          axios.post(url, formData,
            {
              headers: {
                Authorization: idToken,
                'Content-Type': 'multipart/form-data',
              },
            }).then(response => {
            temp.loader('none')
            console.log(response)
            temp.$bvModal
              .msgBoxOk(`${response.data} puzzles imported`, {
                title: 'Info',
                size: 'sm',
                okVariant: 'primary',
                okTitle: 'Close',
                hideHeaderClose: false,
                centered: true,
              })
            return response
          }).catch(error => {
            console.log(error)
            temp.loader('none')
            return error
          })
        })
      }
    },
    onRowSelected(row) {
      const url = `/puzzles/${row[0].id}`
      this.$router.push(url)
    },
    findPuzzles() {
      const url = `${this.$readerURL}/admin/puzzles/${this.selectedBook}/${this.book.chapter}?samples=${this.samples}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.get(url,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.items = response.data
          this.loader('none')
          return response
        }).catch(error => {
          this.loader('none')
          return error
        })
      })
    },
  },
}
</script>
